export default "__VITE_ASSET__2YtiIIWv__"